<div class="row ">

  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">

    <div class="dx-field">
      <div class="dx-field-label">Codice </div>
      <div class="dx-field-value">
        <dx-text-box placeholder="" maxLength="40" [(value)]="dipendente.codice">
          <dx-validator>
            <dxi-validation-rule type="required" message="Inserire il codice">
            </dxi-validation-rule>

          </dx-validator>
        </dx-text-box>

      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Nominativo </div>
      <div class="dx-field-value">
        <dx-text-box placeholder="" maxLength="40" [(value)]="dipendente.nominativo">
          <dx-validator>
            <dxi-validation-rule type="required" message="Inserire il nominativo">
            </dxi-validation-rule>

          </dx-validator>
        </dx-text-box>

      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Attivo </div>
      <div class="dx-field-value">
        <dx-check-box [(value)]="dipendente.attivo"></dx-check-box>

      </div>
    </div>


    <div class="dx-field">
      <div class="dx-field-label">Data di nascita </div>
      <div class="dx-field-value">

        <dx-date-box #data displayFormat="dd/MM/yyyy" [(value)]="dipendente.dataNascita">
          <!-- [height]="26"> -->
          <dx-validator>
            <dxi-validation-rule type="required" message="Inserire la data di nascita">
            </dxi-validation-rule>

          </dx-validator>
        </dx-date-box>

      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Codice fiscale </div>
      <div class="dx-field-value">
        <dx-text-box placeholder="" [maxLength]="20" [(value)]="dipendente.codFiscale">
          <dx-validator>
            <dxi-validation-rule type="pattern" [pattern]="codiceFiscalePattern"
              message="Verificare il formato del codice fiscale">
            </dxi-validation-rule>

          </dx-validator>


        </dx-text-box>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Data di assunzione </div>
      <div class="dx-field-value">

        <dx-date-box #data displayFormat=" dd/MM/yyyy" [(value)]="dipendente.dataAssunzione">
          <!-- [height]="26"> -->
          <!--<dx-validator>
          <dxi-validation-rule
            type="required" message="Inserire la data di assunzione">
          </dxi-validation-rule>

        </dx-validator>-->
        </dx-date-box>

      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Data di licenziamento </div>
      <div class="dx-field-value">

        <dx-date-box #data displayFormat=" dd/MM/yyyy" [(value)]="dipendente.dataLicenziamento">
          <!-- [height]="26"> -->

        </dx-date-box>

      </div>
    </div>
    <div class="dx-field">
      <div class="dx-field-label">Reparto </div>
      <div class="dx-field-value">

        <dx-lookup [displayExpr]="getRepartoDisplayExpr" valueExpr="id" [items]="listReparti" [searchEnabled]="true"
          [(value)]="dipendente.idReparto">

        </dx-lookup>

      </div>
    </div>
    <div class="dx-field">
      <div class="dx-field-label">Responsabile </div>
      <div class="dx-field-value">

        <dx-lookup [displayExpr]="getResponsabileDisplayExpr" valueExpr="id" [dataSource]="listDipendenti"
          [searchEnabled]="true" [(value)]="dipendente.idResponsabile">

        </dx-lookup>

      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Mansione </div>
      <div class="dx-field-value">

        <dx-lookup [displayExpr]="getMansioneDisplayExpr" valueExpr="id" [dataSource]="listMansioni"
          [searchEnabled]="true" [(value)]="dipendente.idMansione" (onValueChanged)="onMansioneValueChanged()">

        </dx-lookup>

      </div>
    </div>

  </div>
  @if (idMansioneOrig != dipendente.idReparto) {
  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
  </div>
  }

</div>

<div class="row">
  <div class="col-12">&nbsp;</div>
</div>
<div class="row">
  <div class="col-12">
    <div class="buttons">
      <div class="buttons-column">
        <div>
          <dx-button stylingMode="contained" text="Salva" icon="save" type="success" width="120"
            (onClick)="SalvaDipendente($event)">
          </dx-button>
        </div>
      </div>

      <div class="buttons-column">
        <div>
          @if (dipendente.attivo) {
          <div>
            <dx-button stylingMode="contained" text="Disattiva" icon="check" width="150" [visible]="!isNew"
              (onClick)="AttivaDisattiva(false)">
            </dx-button>
          </div>
          } @else {
          <dx-button stylingMode="contained" text="Attiva" icon="check" width="150" [visible]="!isNew"
            (onClick)="AttivaDisattiva(true)">
          </dx-button>
          }
        </div>
        <div class="buttons-column">
          <div>
            <dx-button stylingMode="contained" text="Stampa Etichetta" icon="print" width="140"
              (onClick)="stampaEtichetta()"></dx-button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadPanelVisible" [showIndicator]="true"
  [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>

@if(popupInfoBarCode){
<dx-popup [width]="600" [height]="250" [showTitle]="true" title="Informazioni Aggiuntive" [dragEnabled]="false"
  [hideOnOutsideClick]="true" [(visible)]="popupInfoBarCode">
  <app-popup-barcode (popupBarcodeEventEmitter)="onPopupBarcodeEventEmitter($event)"></app-popup-barcode>
</dx-popup>
}